<template>
  <component
    :is="courierDeliveryBannerComponent"
    ref="courierDeliveryBanner"
  />

  <courier-delivery-content
    :document-items="courierDeliveryConfig.documentItems"
    :terminal-brand-name="courierDeliveryConfig.terminalBrandName"
    @select-price-direction="selectPriceDirection"
  />
</template>

<script setup>
import {computed, getCurrentInstance, ref} from 'vue'
import CourierDeliveryContent from '@/components/courier-delivery/CourierDeliveryContent.vue'
import SeverTransCourierDeliveryBanner from '@/components/courier-delivery/SeverTransCourierDeliveryBanner.vue'
import TransportCourierDeliveryBanner from '@/components/courier-delivery/TransportCourierDeliveryBanner.vue'
import UgTransCourierDeliveryBanner from '@/components/courier-delivery/UgTransCourierDeliveryBanner.vue'
import {
  severTransCourierDeliveryConfig,
  transportCourierDeliveryConfig,
  ugTransCourierDeliveryConfig
} from '@/components/courier-delivery/courierDelivery'

const courierDeliveryConfigsByDocumentId = {
  19: severTransCourierDeliveryConfig,
  20: ugTransCourierDeliveryConfig,
  124: transportCourierDeliveryConfig
}

const courierDeliveryBannersByDocumentId = {
  19: SeverTransCourierDeliveryBanner,
  20: UgTransCourierDeliveryBanner,
  124: TransportCourierDeliveryBanner
}

const {companyData} = getCurrentInstance().appContext.config.globalProperties
const courierDeliveryConfig = computed(() => {
  return courierDeliveryConfigsByDocumentId[+companyData.documentId] || severTransCourierDeliveryConfig
})
const courierDeliveryBannerComponent = computed(() => {
  return courierDeliveryBannersByDocumentId[+companyData.documentId] || SeverTransCourierDeliveryBanner
})
const courierDeliveryBanner = ref(null)

function selectPriceDirection(item) {
  courierDeliveryBanner.value?.setDirection(item)
}
</script>
